import type { CollaborationBridgeStore } from "./collaboration-bridge-types";
import { createComponentCreateActions } from "./component-slice-create-actions";
import { createComponentMutationActions } from "./component-slice-mutation-actions";
import { createComponentStructureActions } from "./component-slice-structure-actions";
import type {
  ComponentSlice,
  ComponentSliceState,
} from "./component-slice-types";
import type {
  EditorImmerGetState,
  EditorImmerSetState,
} from "./editor-store-types";

export type { ComponentSlice } from "./component-slice-types";

export function createComponentSlice<
  TState extends ComponentSliceState,
>(
  set: EditorImmerSetState<TState>,
  get: EditorImmerGetState<TState>,
  getCollaborationBridge: () => CollaborationBridgeStore | null,
): ComponentSlice {
  return {
    ...createComponentCreateActions(set, get, getCollaborationBridge),
    ...createComponentMutationActions(set, get, getCollaborationBridge),
    ...createComponentStructureActions(set, get),
  };
}
